import React from 'react'
// import { button } from 'react-router-dom'
import { useNavigator } from '../../utitlities/navigation'
import './styles.css'

function Footer () {
  const [navigator] = useNavigator()
  const navigate = path => {
    navigator(path, {})
  }

  return (
    <section class='footer'>
      <div class='overlay py-5'>
        <div class='container-fluid px-3 px-lg-5 py-3'>
          <div class='row'>
            <div class='col-lg-3 order-last order-lg-first'>
              <img
                class='footer-logo'
                src={`${process.env.REACT_APP_IMAGE_URL}/assets/images/ex-sports-logo.png`}
                alt='comp-logo'
              />
              <p class='pra-top'>
                EX Sport Starz is a platform that allows sport fans to buy,
                trade and sell digital sport collectibles. The app offers a
                variety of sports and has a special reward program for the
                collectors, athletes and sport fans.
              </p>
            </div>
            <div class='col-lg-9 order-first order-lg-last mb-5 mb-lg-0 text-uppercase'>
              <div class='row mx-0'>
                <div class='col-6 col-md-3'>
                  <h1>EX SPORTS</h1>

                  <ul class='footer-nav text-uppercase'>
                    <li class='nav-item'>
                      <a href='/about-us' class='nav-link text-uppercase'>
                        About us
                      </a>
                    </li>

                    <li class='nav-item'>
                      <button
                        // to='/road-map'
                        class='nav-link button'
                        onClick={() => {
                          navigate('/road-map')
                        }}
                      >
                        Roadmap
                      </button>
                    </li>
                    {/* <li class="nav-item">
                                            <a href="#" class="nav-link">
                                                Blog
                                            </a>
                                        </li> */}
                    <li class='nav-item'>
                      <a
                        href='https://www.linkedin.com/company/exsports/jobs/'
                        class='nav-link'
                        target='_blank'
                      >
                        Careers
                      </a>
                    </li>

                    <li class='nav-item'>
                      <button
                        // to='/partnership'
                        class='nav-link button'
                        onClick={() => {
                          navigate('/partnership')
                        }}
                      >
                        PR / Partnership
                      </button>
                    </li>
                  </ul>
                  <h1 className='d-md-none'>Follow us</h1>

                  <ul class='footer-nav text-uppercase d-md-none'>
                    <li class='nav-item'>
                      <a
                        href='https://t.me/exsports_official'
                        class='nav-link'
                        target='_blank'
                      >
                        <i class='fab fa-telegram me-1'></i> Telegram
                      </a>
                    </li>
                    <li class='nav-item'>
                      <a
                        href='https://www.facebook.com/exsportstoken/'
                        class='nav-link'
                        target='_blank'
                      >
                        <i class='fab fa-facebook me-1'></i> Facebook
                      </a>
                    </li>
                    <li class='nav-item'>
                      <a
                        href='https://twitter.com/ExSportsToken'
                        class='nav-link'
                        target='_blank'
                      >
                        <i class='fab fa-twitter me-1'></i> Twitter
                      </a>
                    </li>
                    <li class='nav-item'>
                      <a
                        href='https://discord.com/invite/yrDg9USs3P'
                        class='nav-link'
                        target='_blank'
                      >
                        <i class='fab fa-discord me-1'></i> Discord
                      </a>
                    </li>
                    <li class='nav-item'>
                      <a
                        href='https://www.instagram.com/accounts/login/?next=/exsports.io/'
                        class='nav-link'
                        target='_blank'
                      >
                        <i class='fab fa-instagram me-1'></i> Instagram
                      </a>
                    </li>
                    <li class='nav-item'>
                      <a
                        href='https://www.youtube.com/channel/UCLE_T2kmQvSYzjeqMLmuaYQ'
                        class='nav-link'
                        target='_blank'
                      >
                        <i class='fab fa-youtube me-1'></i> Youtube
                      </a>
                    </li>
                    {/* <li class="nav-item ">
                                            <a href="https://www.reddit.com/user/EX-Sports" class="nav-link" target="_blank">
                                                <i class="fab fa-reddit me-1"></i> Reddit
                                            </a>
                                        </li> */}
                  </ul>
                </div>

                <div class='col-6 col-md-3 text-uppercase'>
                  <h1>Support</h1>

                  <ul class='footer-nav text-uppercase'>
                    <li class='nav-item'>
                      <button
                        // to="/faq"
                        class='nav-link button'
                        onClick={() => {
                          navigate('/faq')
                        }}
                      >
                        FAQ
                      </button>
                    </li>
                    <li class='nav-item'>
                      <button
                        // to='/contact-us'
                        onClick={() => {
                          navigate('/contact-us')
                        }}
                        class='nav-link button'
                      >
                        Contact
                      </button>
                    </li>
                    {/* <li class="nav-item">
                                            <a href="#" class="nav-link">
                                                Subscribe
                                            </a>
                                        </li>
                                        <li class="nav-item">
                                            <a href="#" class="nav-link">
                                                Contact
                                            </a>
                                        </li> */}
                  </ul>

                  <div class='d-md-none text-uppercase'>
                    <h1>Documents</h1>

                    <ul class='footer-nav text-uppercase '>
                      <li class='nav-item'>
                        <a
                          onClick={() => {
                            navigate('/terms-condition')
                          }}
                          // to='/terms-condition'
                          class='nav-link button'
                        >
                          Terms and Conditions
                        </a>
                      </li>
                      <li class='nav-item'>
                        <a
                          onClick={() => {
                            navigate('/privacy')
                          }}
                          // to='/privacy'
                          class='nav-link button'
                        >
                          Privacy Policy
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>

                <div class='col-6 col-md-3 d-none d-md-block text-uppercase'>
                  <h1>Documents</h1>

                  <ul class='footer-nav text-uppercase'>
                    <li class='nav-item'>
                      <button
                        onClick={() => {
                          navigate('/terms-condition')
                        }}
                        // to='/terms-condition'
                        class='nav-link button'
                      >
                        Terms and Conditions
                      </button>
                    </li>
                    <li class='nav-item'>
                      <button
                        onClick={() => {
                          navigate('/privacy')
                        }}
                        // to='/privacy'
                        class='nav-link button'
                      >
                        Privacy Policy
                      </button>
                    </li>
                  </ul>
                </div>

                <div class='col-6 col-md-3 d-none d-md-block'>
                  <h1>Follow us</h1>

                  <ul class='footer-nav text-uppercase'>
                    <li class='nav-item'>
                      <a
                        href='https://t.me/exsports_official'
                        class='nav-link'
                        target='_blank'
                      >
                        <i class='fab fa-telegram me-1'></i> Telegram
                      </a>
                    </li>
                    <li class='nav-item'>
                      <a
                        href='https://www.facebook.com/exsportstoken/'
                        class='nav-link'
                        target='_blank'
                      >
                        <i class='fab fa-facebook me-1'></i> Facebook
                      </a>
                    </li>
                    <li class='nav-item'>
                      <a
                        href='https://twitter.com/ExSportsToken'
                        class='nav-link'
                        target='_blank'
                      >
                        <i class='fab fa-twitter me-1'></i> Twitter
                      </a>
                    </li>
                    <li class='nav-item'>
                      <a
                        href='https://discord.com/invite/yrDg9USs3P'
                        class='nav-link'
                        target='_blank'
                      >
                        <i class='fab fa-discord me-1'></i> Discord
                      </a>
                    </li>
                    <li class='nav-item d-none d-md-block'>
                      <a
                        href='https://www.instagram.com/accounts/login/?next=/exsports.io/'
                        class='nav-link'
                        target='_blank'
                      >
                        <i class='fab fa-instagram me-1'></i> Instagram
                      </a>
                    </li>
                    <li class='nav-item d-none d-md-block'>
                      <a
                        href='https://www.youtube.com/channel/UCLE_T2kmQvSYzjeqMLmuaYQ'
                        class='nav-link'
                        target='_blank'
                      >
                        <i class='fab fa-youtube me-1'></i> Youtube
                      </a>
                    </li>
                    {/* <li class="nav-item d-none d-md-block">
                                            <a href="https://www.reddit.com/user/EX-Sports" class="nav-link" target="_blank">
                                                <i class="fab fa-reddit me-1"></i> Reddit
                                            </a>
                                        </li> */}
                  </ul>
                </div>

                <div class='col-6 col-md-3 d-none'>
                  <ul class='footer-nav mt-5 text-uppercase'>
                    {/* <li class="nav-item">
                                            <a href="https://discord.com/invite/yrDg9USs3P" target='_blank' class="nav-link">
                                                <i class="fab fa-discord me-1"></i> Discord
                                            </a>
                                        </li> */}
                    <li class='nav-item'>
                      <a
                        href='https://www.youtube.com/channel/UCLE_T2kmQvSYzjeqMLmuaYQ'
                        target='_blank'
                        class='nav-link'
                      >
                        <i class='fab fa-youtube me-1'></i> Youtube
                      </a>
                    </li>
                    <li class='nav-item'>
                      <a
                        href='https://www.reddit.com/user/EX-Sports'
                        target='_blank'
                        class='nav-link'
                      >
                        <i class='fab fa-reddit-alien me-1'></i> Reddit
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class='container py-3'>
          <div class='row'>
            <div class='col-12 text-center'>
              <p class='mb-0 pra-bottom text-uppercase'>
                © {new Date()?.getFullYear()} EX SPORTS MARKETPLACE
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Footer
